module.exports = __webpack_public_path__ + "img/feature-work-1-large.152fdb2b.jpg";